// libraries
import {identity} from 'lodash';
import $ from 'jquery';
import {camelizeKeys} from 'humps';

export const RECEIVE_JSON_WEB_TOKEN = 'RECEIVE_JSON_WEB_TOKEN';

const pendingRequests = {};

const req = ({
  url,
  method,
  headers,
  data,
  responseTransformer,
  dataType,
  cancelPendingRequests = false
}) => {
  if (url === undefined) { throw new Error('URL is undefined'); }

  responseTransformer = responseTransformer || identity;
  method = method || 'GET';
  dataType = dataType || 'json';
  let params = {dataType};
  const baseUrl = url.split('?')[0];

  switch (method.toLowerCase()) {
    case 'patch':
    case 'post':
    case 'put':
      params.data = JSON.stringify(data);
      params.contentType = 'application/json';
      break;
    default:
      params.data = data;
      break;
  }

  if (cancelPendingRequests) {
    params.complete = (r) => {
      pendingRequests[baseUrl] = pendingRequests[baseUrl].filter((item) => item === r);
    };
  }

  return new Promise((resolve, reject) => {
    const request = $.ajax({
      url,
      method,
      headers,
      ...params
    }).done((res, textStatus, jqXhr) => {
      resolve(responseTransformer(res, textStatus, jqXhr));
    }).fail((res, textStatus) => {
      if (res.status >= 500 && window.Raven) {
        window.Raven.captureMessage(res.responseText);
      }

      if (textStatus !== 'abort') {
        reject(res.responseJSON, textStatus);
      }
    });

    if (cancelPendingRequests) {
      pendingRequests[baseUrl] = pendingRequests[baseUrl] || [];
      pendingRequests[baseUrl].forEach((r) => r.abort());
      pendingRequests[baseUrl].push(request);
    }
  });
};

export default req;

export const rejectCamelizedErrors = (errors) => {
  return Promise.reject(camelizeKeys(errors));
};

export const rejectGenericError = (responseJSON) => {
  if (!responseJSON) {
    return Promise.reject({
      _error: 'Oh snap! An error occurred. Please refresh the page and try again.'
    });
  }
  return Promise.reject(responseJSON);
};

export const authenticatedRequest = (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    const {jsonWebToken} = getState();

    if (jsonWebToken) {
      resolve(jsonWebToken);
    } else {
      req({url: '/v1/basic/token'}).then(({token}) => {
        dispatch(receiveJSONWebToken(token));
        resolve(token);
      }).catch(reject);
    }
  });
};

export const receiveJSONWebToken = (token) => ({
  type: RECEIVE_JSON_WEB_TOKEN,
  token
});
